import React from "react";

// =====================================================================
// Loan / Buy segmented control — a quick switch next to the Filters button
// on the Requests pages. Drives the same `type_of_tender` filter the filter
// modal uses (the backend list endpoint filters on type_of_tender), so it
// stays in sync with the modal's Request Type dropdown. "All" clears the
// buy/loan restriction.
//
// Shared by the AGENT/agency view (AgentTenders.js) and the CLUB view
// (club DesktopHeader) so both sides behave identically — single source of
// truth, no divergent duplicated markup.
//
// Props:
//   value    — current filters.type_of_tender ("all" | "buy" | "loan" | …)
//   onChange — called with the picked value ("all" | "buy" | "loan")
// =====================================================================
const OPTIONS = [
  { value: "all", label: "All" },
  { value: "buy", label: "Buy" },
  { value: "loan", label: "Loan" },
];

const LoanBuySwitch = ({ value, onChange }) => {
  const current = value || "all";
  return (
    <div className="inline-flex items-center border border-[#E6E6E6] rounded-lg p-0.5">
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          className={`px-3 py-1.5 text-sm rounded-md transition ${
            current === opt.value
              ? "bg-[#E9F3FF] text-[#2283FF] font-medium"
              : "text-[#1E1E1ECC] hover:bg-gray-50"
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
};

export default LoanBuySwitch;
